import React from 'react';

type FloatingType = 'text' | 'number' | 'date';

interface OperatorOption {
    value: string;
    label: string;
}

const OPERATORS: { [key in FloatingType]: OperatorOption[] } = {
    text: [
        {value: 'contains', label: 'Contém'},
        {value: 'notContains', label: 'Não contém'},
        {value: 'equals', label: 'Igual a'},
        {value: 'notEqual', label: 'Diferente'},
        {value: 'startsWith', label: 'Inicia com'},
        {value: 'endsWith', label: 'Termina com'},
    ],
    number: [
        {value: 'equals', label: '='},
        {value: 'notEqual', label: '≠'},
        {value: 'greaterThan', label: '>'},
        {value: 'greaterThanOrEqual', label: '≥'},
        {value: 'lessThan', label: '<'},
        {value: 'lessThanOrEqual', label: '≤'},
    ],
    date: [
        {value: 'equals', label: 'Igual'},
        {value: 'greaterThan', label: 'Após'},
        {value: 'lessThan', label: 'Antes'},
    ],
};

const DEFAULT_OPERATOR: { [key in FloatingType]: string } = {
    text: 'contains',
    number: 'equals',
    date: 'equals',
};

interface State {
    operator: string;
    value: string;
}

class OperatorFloatingFilter extends React.Component<any, State> {
    private timer: any = null;
    private pendingApply = false;

    constructor(props: any) {
        super(props);
        const type = this.getType();
        this.state = {operator: DEFAULT_OPERATOR[type], value: ''};
    }

    componentWillUnmount() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }

    getReactContainerStyle() {
        return {
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            height: '100%',
            flex: '1 1 auto',
        };
    }

    getType(): FloatingType {
        const filter = this.props.column.getColDef().filter;
        if (filter === 'agNumberColumnFilter') {
            return 'number';
        }
        if (filter === 'agDateColumnFilter') {
            return 'date';
        }
        return 'text';
    }

    onParentModelChanged(parentModel: any) {
        if (this.pendingApply) {
            return;
        }
        const type = this.getType();
        if (!parentModel) {
            this.setState({value: ''});
            return;
        }
        const condition = parentModel.operator ? (parentModel.condition1 || parentModel) : parentModel;
        const value = type === 'date'
            ? (condition.dateFrom ? String(condition.dateFrom).substring(0, 10) : '')
            : (condition.filter != null ? String(condition.filter) : '');
        this.setState({operator: condition.type || this.state.operator, value});
    }

    hasValue(): boolean {
        return this.state.value !== '' && this.state.value != null;
    }

    apply() {
        const type = this.getType();
        const {operator, value} = this.state;
        this.props.parentFilterInstance((instance: any) => {
            if (value === '' || value == null) {
                instance.setModel(null);
            } else if (type === 'date') {
                instance.setModel({type: operator, dateFrom: value + ' 00:00:00'});
            } else if (type === 'number') {
                instance.setModel({type: operator, filter: Number(value)});
            } else {
                instance.setModel({type: operator, filter: value});
            }
        });
        this.props.api.onFilterChanged();
    }

    handleOperator = (event: any) => {
        const operator = event.target.value;
        this.setState({operator}, () => {
            if (this.hasValue()) {
                this.pendingApply = false;
                this.apply();
            }
        });
    };

    handleValue = (event: any) => {
        const value = event.target.value;
        this.pendingApply = true;
        this.setState({value});
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
            this.pendingApply = false;
            this.apply();
        }, 400);
    };

    render() {
        const type = this.getType();
        const inputType = type === 'number' ? 'number' : (type === 'date' ? 'date' : 'text');
        const controlStyle: React.CSSProperties = {
            fontSize: 13,
            height: 26,
            border: '1px solid #babfc7',
            borderRadius: 3,
            background: '#fff',
            color: '#181d1f',
            boxSizing: 'border-box',
        };
        return (
            <React.Fragment>
                <select
                    title="Operador"
                    value={this.state.operator}
                    onChange={this.handleOperator}
                    style={{...controlStyle, flex: '0 1 auto', minWidth: 24, marginRight: 4}}
                >
                    {OPERATORS[type].map((operator) => (
                        <option key={operator.value} value={operator.value}>{operator.label}</option>
                    ))}
                </select>
                <input
                    type={inputType}
                    value={this.state.value}
                    onChange={this.handleValue}
                    placeholder="Valor..."
                    style={{...controlStyle, flex: '1 1 auto', minWidth: 44, width: '100%', padding: '0 6px'}}
                />
            </React.Fragment>
        );
    }
}

export default OperatorFloatingFilter;
